interface ErrorMessageProps {
  message?: string;
  classes?: string;
}

const ErrorMessage = ({ message = "", classes = "" }: ErrorMessageProps) => {
  return <>{message && <p className={`mt-1 text-xs text-error ${classes}`}>{message}</p>}</>;
};

export default ErrorMessage;
